<h2 mat-dialog-title>{{id? 'Update Admin' : 'Add Admin'}}</h2>
<form [formGroup]="addUserForm" (ngSubmit)="onFormSubmit()">
    <div mat-dialog-content class="content">
        <div class="column">

            <mat-form-field appearance="outline">
                <mat-label>Event</mat-label>
                <mat-select [ngModel]="event_id" formControlName="event_id" matInput placeholder="Select Event">
                    <mat-option *ngFor="let data of eventmain" [value]="data.event_id">
                        {{data.event_name}}
                    </mat-option>
                    <!-- <mat-option value=0>All Event</mat-option> -->
                </mat-select>
            </mat-form-field>
        </div>
        <div class="column">

            <mat-form-field appearance="outline">
                <mat-label>Mobile</mat-label>
                <input [ngModel]="mobile" formControlName="mobile" maxlength="10" matInput
                    placeholder="Enter Your Registered Mobile Number" (input)="onMobileInputChange()">
            </mat-form-field>

            <!-- <mat-form-field appearance="outline">
                <mat-label>Mobile</mat-label>
                <input [ngModel]="mobile" formControlName="mobile" maxlength="10" matInput
                    placeholder="Enter Your Mobile Number" (input)="onMobileInputChange()">
            </mat-form-field> -->

        </div>

        <div class="column">
            <mat-form-field appearance="outline" class="flex-1">
                <mat-label>Password</mat-label>

                <input matInput [ngModel]="user_pwd" formControlName="user_pwd" [readonly]="!isResetMode"
                    [type]="isResetMode ? 'text' : 'password'" placeholder="Enter Password">

                <!-- Reset Icon -->
                <button *ngIf="!isResetMode" mat-icon-button matSuffix type="button" (click)="resetPassword()"
                    matTooltip="Reset Password">
                    <mat-icon color="warn">edit</mat-icon>
                </button>

            </mat-form-field>
        </div>

        <div class="column">

            <mat-form-field appearance="outline">
                <mat-label>Username</mat-label>
                <input [ngModel]="user_name" formControlName="user_name" matInput placeholder="Enter User Name">

            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Role</mat-label>
                <mat-select [ngModel]="role" formControlName="role">
                    <mat-option value="subadmin">Sub-Admin</mat-option>
                    <mat-option value="volunteer">Volunteer</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div mat-dialog-actions class="action" align="end">
            <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
            <button mat-raised-button type="submit" color="primary">{{id? 'Update' : 'Add'}}</button>
        </div>
    </div>
</form>